module.exports = __webpack_public_path__ + "assets/images/project/head/Syed_Saddiq.jpg?v=05e7774a";